import React, { useEffect, useState } from "react";
import {
  Chip,
  Popover,
  IconButton,
  Tooltip,
  makeStyles,
  Box,
  Typography,
} from "@material-ui/core";
import LabelIcon from "@material-ui/icons/Label";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  button: {
    alignSelf: "center",
    marginLeft: theme.spacing(1),
  },
  popover: {
    padding: theme.spacing(2),
    maxWidth: 280,
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.8),
  },
  chip: {
    cursor: "pointer",
    fontWeight: 500,
  },
}));

const TicketLabelSelector = ({ ticket, onLabelsChange }) => {
  const classes = useStyles();
  const [allLabels, setAllLabels] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    api.get("/labels").then(({ data }) => setAllLabels(data)).catch(toastError);
  }, []);

  useEffect(() => {
    if (ticket?.contact?.labels) {
      setSelectedIds(ticket.contact.labels.map(l => l.id));
    }
  }, [ticket]);

  const handleOpen = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleToggle = async (labelId) => {
    const next = selectedIds.includes(labelId)
      ? selectedIds.filter(id => id !== labelId)
      : [...selectedIds, labelId];

    setSelectedIds(next);
    try {
      const { data } = await api.put(`/contacts/${ticket.contact.id}/labels`, {
        labelIds: next,
      });
      if (onLabelsChange) onLabelsChange(data);
    } catch (err) {
      toastError(err);
      setSelectedIds(selectedIds);
    }
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Etiquetas do cliente">
        <IconButton size="small" className={classes.button} onClick={handleOpen}>
          <LabelIcon
            style={{ color: selectedIds.length > 0 ? "#7C4DFF" : undefined }}
          />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box className={classes.popover}>
          <Typography className={classes.title}>Etiquetas do cliente</Typography>
          <div className={classes.chipContainer}>
            {allLabels.length === 0 && (
              <Typography variant="body2" color="textSecondary">
                Nenhuma etiqueta cadastrada.
              </Typography>
            )}
            {allLabels.map(label => {
              const selected = selectedIds.includes(label.id);
              return (
                <Chip
                  key={label.id}
                  label={label.name}
                  size="small"
                  className={classes.chip}
                  onClick={() => handleToggle(label.id)}
                  style={{
                    backgroundColor: selected ? label.color : undefined,
                    color: selected ? "#fff" : undefined,
                    border: `2px solid ${label.color}`,
                  }}
                />
              );
            })}
          </div>
        </Box>
      </Popover>
    </>
  );
};

export default TicketLabelSelector;
